import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'

import { GET_DELEGATE_ACCESS_GIVEN } from '../../entities/delegateAccess/service/query'

const useSurrogateAccess = () => {
  const { isUserLoggedIn } = useSelector(state => state.auth)
  const { data, error, loading, refetch } = useQuery(GET_DELEGATE_ACCESS_GIVEN, {
    skip: !isUserLoggedIn,
  })

  return { data: data && data.delegateAccess_getGiven, error, loading, refetch }
}

export default useSurrogateAccess
